import { z } from "zod";

import { passwordValidator } from "@/core/schemas/password";
import { m } from "@/paraglide/messages";

export const resetPasswordSchema = z
  .object({
    password: passwordValidator,
    passwordConfirm: passwordValidator,
  })
  .refine((data) => data.password === data.passwordConfirm, {
    path: ["passwordConfirm"],
    message: m.passwords_do_not_match(),
  });

export type ResetPasswordSchema = z.infer<typeof resetPasswordSchema>;
